module.exports = __webpack_public_path__ + "static/media/heartworklogo.387f4d77.png";